<template>
    <div class="pay">
        <div class="grouping">
            <p :class="[template==='pay'?'opt':'','btn']" @click="template='pay'">微信/支付宝(自助)</p>
            <p :class="[template==='tbpay'?'opt':'','btn']" @click="template='tbpay'">淘宝卡密充值(自助)</p>
            <p :class="[template==='company_pay'?'opt':'','btn']" @click="template='company_pay'">对公转账充值</p>
            <p :class="[template==='invoice_information'?'opt':'','btn']" @click="template='invoice_information'">开票信息编辑</p>
            <p :class="[template==='pay_record'?'opt':'','btn']" @click="template='pay_record'">充值续费记录</p>
            <!-- <p :class="[template==='invoice_apply'?'opt':'','btn']" @click="template='invoice_apply'">申请发票</p> -->
        </div>
        <div class="gui">
            <div v-if="template==='pay'">
                <Pay></Pay>
            </div>
            <div v-else-if="template==='tbpay'">
                <TbPay></TbPay>
            </div>
            <div v-else-if="template==='company_pay'">
                <CompanyPay></CompanyPay>
            </div>
            <div v-else-if="template==='pay_record'">
                <PayRecord @switchover="switchover"></PayRecord>
            </div>
            <div v-else-if="template==='invoice_information'">
                <InvoiceInformation @switchover="switchover"></InvoiceInformation>
            </div>
            <div v-else-if="template==='invoice_apply'">
                <InvoiceApply></InvoiceApply>
            </div>
        </div>
    </div>
</template>

<script>
    import Pay from './../components/pay/Pay'
    import TbPay from './../components/pay/TbPay'
    import CompanyPay from './../components/pay/CompanyPay'
    import PayRecord from './../components/pay/PayRecord'
    import InvoiceInformation from './../components/pay/InvoiceInformation'
    import InvoiceApply from './../components/pay/InvoiceApply'

    export default {
        data() {
            return {
                template: "pay"
            }
        },
        methods: {
            switchover (tm) {
                this.template = tm
            }
        },
        components: {
            Pay,
            TbPay,
            CompanyPay,
            PayRecord,
            InvoiceInformation,
            InvoiceApply
        }
    }
</script>
<style scoped>
    .pay {
        width: 1030px;
        margin: 0 auto;
        display: flex;
    }

    .grouping {
        width: 320px;
        padding-top: 20px;
        padding-left: 40px;
    }
    .grouping2 {
        width: 240px;
    }
    .gui {
        flex: 1;
        padding: 23px;
        font-size: 16px;
    }

    .btn {
        width: 183px;
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        border: 1px solid #000;
        background-color: #04AFEF;
        margin: 12px;
        padding: 3px;
        text-align: center;
        cursor: pointer;
    }

    .opt {
        color: #fff;
        background-color: #0088cc;
    }

    .btn:hover {
        background-color: #0088cc;
    }
</style>